<cbc-container [isLoading]="isLoading()" [showContainer]="!isLoading()" title="Busca Avançada"
  description="Configure sua busca em etapas simples e intuitivas">
</cbc-container>

@if(!isLoading() || currentWizardStep() === 0) {
<div class="container" [class.is_mobile]="isMobile()">

  <!-- Wizard Container -->
  <app-search-wizard [steps]="wizardSteps()" [initialStepIndex]="currentWizardStep()"
    [stepValidator]="validateWizardStep.bind(this)" (stepChange)="onWizardStepChange($event)"
    (complete)="onWizardComplete()">

    <!-- Step 0: Plan Selection -->
    @if (currentWizardStep() === 0) {
    <div class="wizard-step-content">
      <!-- Skeleton durante carregamento -->
      @if (isLoading()) {
      <app-skeleton-loader [config]="{ type: 'form', count: 3, animation: 'wave' }"></app-skeleton-loader>
      }

      <!-- Se não tiver planos disponíveis -->
      @if (!isLoading() && allPlanStatuses().length === 0) {
      <div class="card card-white">
        <div class="card-body">
          <div class="alert alert-warning">
            <mat-icon>warning</mat-icon>
            <div>
              <p>Para usar a pesquisa você precisa ter um plano ativo. Por favor, adquira um plano para continuar.</p>
            </div>
          </div>
          <div style="text-align: center; margin-top: 1rem;">
            <a mat-flat-button color="primary" routerLink="/produtos">Ver planos e produtos</a>
          </div>
        </div>
      </div>
      }

      <!-- Se tiver planos disponíveis -->
      @if (!isLoading() && allPlanStatuses().length > 0) {
      <div class="card card-white">
        <div class="card-header">
          <h3 class="card-title">Selecione o plano</h3>
          <p class="card-description">Escolha o plano que deseja usar para realizar a busca</p>
        </div>
        <div class="card-body">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Plano</mat-label>
            <mat-select [value]="selectedPlan()?.planName || allPlanStatuses()[0]?.planName" (selectionChange)="onPlanSelected($event.value)">
              @for (p of allPlanStatuses(); track p.planName) {
              <mat-option [value]="p.planName">{{ p.planName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (selectedPlan()) {
          <div class="alert alert-info">
            <mat-icon>info</mat-icon>
            <span>Plano selecionado: <strong>{{ selectedPlan()?.planName }}</strong></span>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }

    <!-- Step 1: Search Type Selection -->
    @if (currentWizardStep() === 1) {
    <div class="wizard-step-content">
      <!-- Skeleton durante carregamento -->
      @if (isLoading()) {
      <app-skeleton-loader [config]="{ type: 'card', count: 4, animation: 'wave' }"></app-skeleton-loader>
      }

      @if (!isLoading()) {
      <div class="card card-white">
        <div class="card-header">
          <h3 class="card-title">Tipo de Busca</h3>
          <p class="card-description">Escolha o tipo de pesquisa que deseja realizar</p>
        </div>
        <div class="card-body">
          <div class="search-type-grid" [class.mobile]="isMobile()">
            @for (option of getAvailableSearchTypes(); track option.key) {
            <button class="search-type-card" [class.selected]="selectedSearchType() === option.key"
              (click)="selectSearchType(option.key)">
              <mat-icon>{{ option.icon }}</mat-icon>
              <span>{{ option.label }}</span>
            </button>
            }
          </div>

          @if (getAvailableSearchTypes().length === 0) {
          <div class="alert alert-warning">
            <mat-icon>warning</mat-icon>
            <span>Nenhum tipo de busca disponível para este plano.</span>
          </div>
          }

          @if (selectedSearchType()) {
          <div class="alert alert-success">
            <mat-icon>check_circle</mat-icon>
            <span>Tipo selecionado: <strong>{{ getSelectedSearchTypeLabel() }}</strong></span>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }

    <!-- Step 2: Search Form -->
    @if (currentWizardStep() === 2) {
    <div class="wizard-step-content">
      <!-- Skeleton durante carregamento -->
      @if (isLoading()) {
      <app-skeleton-loader
        [config]="{ type: 'form', count: 8, animation: 'wave', height: '60px' }"></app-skeleton-loader>
      }

      @if (!isLoading() && currentSearchConfig()) {
      <div class="form-container-large">
        @if (selectedTypeForm() === 'SERVICE') {
        <app-advanced-search-service-form [searchConfig]="currentSearchConfig()!"></app-advanced-search-service-form>
        }

        @if (selectedTypeForm() === 'RESOURCE') {
        <app-advanced-search-resource-form [searchConfig]="currentSearchConfig()!"></app-advanced-search-resource-form>
        }
      </div>
      }
    </div>
    }

  </app-search-wizard>

</div>
}